import $ from "jquery"

$(window).on('load', function(){
    $('.js-hero-ehealth').addClass('loaded');
});